import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/sharp-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/sharp-solid-svg-icons/faChevronDown';
import React from 'react';
import { Text, TextType } from 'ui-components/components/text';

import style from './feature-group-header-row.module.less';
import { FeatureCell } from '../feature-cell/feature-cell';

/**
 * @typedef {import('../../../../../../../../prop-types/subscription-data-types.d.ts').BillingPlan} BillingPlan
 */

/**
 * @typedef {import('../../../../../../../../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {string} props.currentPlanId
 * @param {boolean} props.isExpanded
 * @param {boolean} props.isLastSection
 * @param {BillingPlan[]} props.plans
 * @param {MessageDescriptor} props.sectionTitleMessageDescriptor
 * @param {string} props.selectedPlanId
 * @param {() => void} props.toggleIsExpanded
 * @returns {React.JSX.Element}
 */
export const FeatureGroupHeaderRow = ({
  currentPlanId,
  isExpanded,
  isLastSection,
  plans,
  sectionTitleMessageDescriptor,
  selectedPlanId,
  toggleIsExpanded,
}) => {
  return (
    <>
      <div className={style['section-title-container']} onClick={toggleIsExpanded}>
        <Text textType={TextType.H4} value={sectionTitleMessageDescriptor} />
        <FontAwesomeIcon className={style['section-expander-icon']} icon={isExpanded ? faChevronUp : faChevronDown} />
      </div>

      {/* Empty cells for each plan to maintain column structure and highlighting */}
      {plans.map((plan) => {
        return (
          <FeatureCell
            key={plan.billingPlanId}
            hideRowDivider
            isCurrentPlanColumn={plan.billingPlanId === currentPlanId}
            isLastRowInColumn={isLastSection ? !isExpanded : null}
            isSelectedPlanColumn={plan.billingPlanId === selectedPlanId}
          />
        );
      })}
    </>
  );
};
